/* src/app/main/pages/apps/apps-banner/apps-banner.component.css */
.apps-banner-row {
  background-image:
    linear-gradient(
      to left,
      rgb(255 255 255 / 0),
      rgb(33 54 84 / 0.5)),
    url(/assets/images/apps/app-banner-croped.jpg);
  height: 450px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border-bottom: 10px solid #F2F2F2;
}
@media all and (-ms-high-contrast: none) {
  .apps-banner-row {
    background-image: url(/assets/images/apps/app-banner-croped.jpg);
  }
}
.apps-banner-row h1 {
  font-size: 56px;
}
.apps-banner-row p {
  font-family: "D-DIN";
  font-size: 30px;
  font-weight: 600;
  color: transparent;
}
.apps-banner-row .fa-plane {
  color: #AAAAAA;
  background-color: #fff;
  padding: 10px 8px;
}
@media (min-width: 1600px) {
  .apps-banner-row {
    height: 700px;
  }
}
@media (min-width: 1600px) {
  .apps-banner-row h1 {
    font-size: 89px;
  }
  .apps-banner-row p {
    font-size: 40px !important;
  }
}
@media (device-width: 1440px) {
  .apps-banner-row {
    height: 530px;
  }
}
@media (max-width: 768px) {
  .apps-banner-row {
    height: 300px;
  }
}
/*# sourceMappingURL=apps-banner.component.css.map */
